import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/base.scss';
import './i18nextConf';
import AppProvider from './providers/AppProvider';
import AppLoader from './system/AppLoader';
import AppInit from './system/AppInit';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(AppLoader, { children: _jsx(AppProvider, { children: _jsx(AppInit, {}) }) }) }));
